// @ts-check
import RoleTab from './tab.js';

RoleTab.define('role-tab');

export default RoleTab;
export * from './tab.js';

/**
 * @type {import("./tab-globals.js")}
 */
